export function DirectIndexIcon() {
  return (
    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="23" height="15" rx="7.5" fill="url(#paint0_linear_638_27811)" />
      <path
        d="M8.66 7.3335L6 10.0002L8.66 12.6668V10.6668H13.3333V9.3335H8.66V7.3335ZM18 6.00016L15.34 3.3335V5.3335H10.6667V6.66683H15.34V8.66683L18 6.00016Z"
        fill="#B17518"
      />
      <rect x="0.5" y="0.5" width="23" height="15" rx="7.5" stroke="#F1B962" />
      <defs>
        <linearGradient
          id="paint0_linear_638_27811"
          x1="21.3559"
          y1="1.94426e-06"
          x2="1.19559"
          y2="1.43189"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B861" />
          <stop offset="1" stopColor="#FEE7C2" />
        </linearGradient>
      </defs>
    </svg>
  );
}
